import { render, staticRenderFns } from "./Cancelled.vue?vue&type=template&id=531a46d6&"
import script from "./Cancelled.vue?vue&type=script&lang=ts&"
export * from "./Cancelled.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports